import weatherCodes from './codes.json';

export const codes = weatherCodes;
export { default as getWeather } from './getWeather';
export const findCode = code => weatherCodes.find(({ code: c }) => code === c);
